import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/HSYWeb'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    //PC端页面路由
    {
      path: '/',
      component: Home,
      children:[
        {
          path:'/',
          name: 'PCHome',
          component: () => import('../views/PC/PCHome')},
        {
          path:'/PCProject',
          name: 'PCProject',
          component: () => import('../views/PC/PCProject'),},
        {
          path:'/PCAboutUs',
          name: 'PCAboutUs',
          component: () => import('../views/PC/PCAboutUs')},
        {
          path:'/PCNews',
          name: 'PCNews',
          component: () => import('../views/PC/PCNews'),},
        {
          path:'/News001',
          name:'News001',
          component: () => import('../views/PC/PCNews/News001')},
        {
          path:'/News002',
          name:'News002',
          component: () => import('../views/PC/PCNews/News002')},
        {
          path:'/News003',
          name:'News003',
          component: () => import('../views/PC/PCNews/News003')},
        {
          path:'/News004',
          name:'News004',
          component: () => import('../views/PC/PCNews/News004')},
        {
          path:'/News005',
          name:'News005',
          component: () => import('../views/PC/PCNews/News005')},
        {
          path:'/News006',
          name:'News006',
          component: () => import('../views/PC/PCNews/News006')},  
        {
          path:'/News007',
          name:'News007',
          component: () => import('../views/PC/PCNews/News007')},  
        {
          path:'/News008',
          name:'News008',
          component: () => import('../views/PC/PCNews/News008')},  
        {
          path:'/News009',
          name:'News009',
          component: () => import('../views/PC/PCNews/News009')},  
        {
          path:'/News010',
          name:'News010',
          component: () => import('../views/PC/PCNews/News010')},  
        {
          path:'/News011',
          name:'News011',
          component: () => import('../views/PC/PCNews/News011')},  
        {
          path:'/News012',
          name:'News012',
          component: () => import('../views/PC/PCNews/News012')},  
        {
          path:'/Project001',
          name:'Project001',
          component: () => import('../views/PC/PCProject/Project001')},
        {
          path:'/Project002',
          name:'Project002',
          component: () => import('../views/PC/PCProject/Project002')},
        {
          path:'/Project003',
          name:'Project003',
          component: () => import('../views/PC/PCProject/Project003')},
        {
          path:'/Project004',
          name:'Project004',
          component: () => import('../views/PC/PCProject/Project004')},
        {
          path:'/Project005',
          name:'Project005',
          component: () => import('../views/PC/PCProject/Project005')},
        {
          path:'/Project006',
          name:'Project006',
          component: () => import('../views/PC/PCProject/Project006')},
      ]
    },
    //移动端页面路由
    {
      path:'/MHSYWeb',
      name: 'MHSYWeb',
      redirect: '/MHome',
      component: () => import('../views/Mobile/MHSYWeb'),
      children:[
        {
          path:'/MHome',
          name: 'MHome',
          component: () => import('../views/Mobile/MHome')},
        {
          path:'/MNews',
          name: 'MNews',
          component: () => import('../views/Mobile/MNews')},
        {
          path:'/MAboutUs',
          name: 'MAboutUs',
          component: () => import('../views/Mobile/MAboutUs')},
        {
          path:'/MProject',
          name: 'MProject',
          component: () => import('../views/Mobile/MProject')},
        {
          path:'/MNews001',
          name:'MNews001',
          component: () => import('../views/Mobile/MNews/MNews001')},
        {
          path:'/MNews002',
          name:'MNews002',
          component: () => import('../views/Mobile/MNews/MNews002')},
        {
          path:'/MNews003',
          name:'MNews003',
          component: () => import('../views/Mobile/MNews/MNews003')},
        {
          path:'/MNews004',
          name:'MNews004',
          component: () => import('../views/Mobile/MNews/MNews004')},
        {
          path:'/MNews005',
          name:'MNews005',
          component: () => import('../views/Mobile/MNews/MNews005')},
        {
          path:'/MNews006',
          name:'MNews006',
          component: () => import('../views/Mobile/MNews/MNews006')},
        {
          path:'/MNews007',
          name:'MNews007',
          component: () => import('../views/Mobile/MNews/MNews007')},
        {
          path:'/MNews008',
          name:'MNews008',
          component: () => import('../views/Mobile/MNews/MNews008')},
        {
          path:'/MNews009',
          name:'MNews009',
          component: () => import('../views/Mobile/MNews/MNews009')},
        {
          path:'/MNews010',
          name:'MNews010',
          component: () => import('../views/Mobile/MNews/MNews010')},
        {
          path:'/MNews011',
          name:'MNews011',
          component: () => import('../views/Mobile/MNews/MNews011')},
        {
          path:'/MNews012',
          name:'MNews012',
          component: () => import('../views/Mobile/MNews/MNews012')},
        {
          path:'/MProject001',
          name:'MProject001',
          component: () => import('../views/Mobile/MProject/MProject001')},
        {
          path:'/MProject002',
          name:'MProject002',
          component: () => import('../views/Mobile/MProject/MProject002')},
        {
          path:'/MProject003',
          name:'MProject003',
          component: () => import('../views/Mobile/MProject/MProject003')},
        {
          path:'/MProject004',
          name:'MProject004',
          component: () => import('../views/Mobile/MProject/MProject004')},
        {
          path:'/MProject005',
          name:'MProject005',
          component: () => import('../views/Mobile/MProject/MProject005')},
        {
          path:'/MProject006',
          name:'MProject006',
          component: () => import('../views/Mobile/MProject/MProject006')},
      ]
    },
  ]
})





// WEBPACK FOOTER //
// ./src/router/index.js